export const businessData = {
  certificate: {
    image: "/Business_Info1.png",
    title: "소방완비필증",
    description:
      "다중이용업소에 소방시설등 및 영업장 내부 피난통로 그 밖의 안전시설이 적법하게 설치된 경우 적법사실을 소방서장이 증명하는 증명서를 발급받아야 영업허가를 받을 수 있습니다.",
    contents: [
      {
        content:
          "휴게음식점영업, 제과점영업, 일반음식점영업 - 바닥면적 합계가 100㎡인 곳 (지하층에 설치된 경우에는 66㎡ 이상)",
        subContent: null,
      },
      {
        content:
          "학원 - 수용인원이 300명 이상인 학원 (1. 기숙사 구비, 2. 학원이 2이상(수용인원 300명 이상), 3. 하나 이상의 다중이용업과 함께 있는 경우)",
        subContent: null,
      },
      {
        content:
          "목욕장업 - 시설을 갖춘 수용인원 100명 이상, 찜질방, 안마시술소",
        subContent: null,
      },
      {
        content:
          "오락실, PC방: 게임제공업·인터넷컴퓨터게임시설제공업 및 복합유통게임제공업",
        subContent: null,
      },
      {
        content: "단란주점, 유흥주점, 비디오감상, 비디오물소극장, 영화관",
        subContent: null,
      },
      {
        content: "전화방, 수면방, 화상대화방, 고시원, 콜라텍업",
        subContent: null,
      },
      {
        content:
          "실내스크린골프연습장, 노래연습장, 복합유통제공업, 산후조리원, 실내권총사격장",
        subContent: null,
      },
      {
        content: "방탈출카페, 키즈카페, 만화카페",
        subContent: null,
      },
    ],
  },
  facility: {
    image: "/Business_Info2.png",
    title: "소방시설공사",
    description:
      "건축물에 설치되는 소방시설을 화재안전기준에 적합하도록 설치하는 신설공사와 관리 또는 결핍사항에 대한 보수공사를 수행합니다",
    contents: [
      {
        content:
          "신축, 증축, 개축, 재축, 대수선 또는 구조와 용도 변경으로 신설하는 공사(명함넣기)",
        subContent: [
          "가) 옥내소화전설비, 옥외소화전설비, 스프링쿨러설비, 간이스프링쿨러설비, 물분무소화설비, 포소화설비, 이산화탄소화설비, 할로겐화합물소화설비, 청정소화약제소화설비 및 분말소화설비, 연결송수관설비, 연결살수설비, 제연설비, 소화용수설비 또는 연소방지설비",
        ],
      },
      {
        content:
          "증축, 개축, 재축 대수선 또는 구조와 용도 변경되는 다음의 설비 또는 구역 등을 증설하는 공사(명함)",
        subContent: [
          "가) 옥내소화전 설비, 옥외소화전 설비, 스프링쿨러설비, 간이스프링쿨러 설비 또는 물분무 등 소화설비의 방호구역, 자동화재탐지설비의 경계구역, 제연설비의 제연구역, 연결살수설비의 살수구역, 연결송수관설비의 송수구역, 비상콘센트설비의 전용회로, 연소방지설비의 방지구역",
        ],
      },
      {
        content:
          "소방시설 등을 구성하는 다음의 전부 또는 일부 교체하거나 보수하는 공사(명함)",
        subContent: ["가) 수신반, 소화펌프, 동력(감시)제어반"],
      },
    ],
  },
  sprinkler: {
    image: "/Business_Info3.png",
    title: "스프링클러",
    description:
      "스프링클러는 주변에 물을 뿌리는 살수장치로 화재의 초기 소화 목적으로 사용됩니다, 이와 같은 장소에 설치할수있습니다.",
    contents: [
      {
        content:
          "층수가 6층 이상인 특정소방대상물의 경우에는 모든 층. 다만, 다음의 어느 하나에 해당하는 경우는 제외한다.",
        subContent: [
          "가) 스프링클러설비가 없는 기존의 특정소방대상물을 용도변경하는 경우. 다만, 2)부터 6)까지 및 9)부터 12)까지의 규정에 해당하는 특정소방대상물로 용도변경하는 경우에는 해당 규정에 따라 스프링클러설비를 설치한다.",
        ],
      },
      {
        content:
          "기숙사(교육연구시설·수련시설 내에 있는 학생 수용을 위한 것을 말한다) 또는 복합건축물로서 연면적 5천㎡ 이상인 경우에는 모든 층",
        subContent: null,
      },
      {
        content:
          "문화 및 집회시설(동·식물원은 제외한다), 종교시설(주요구조부가 목조인 것은 제외한다), 운동시설(물놀이형 시설 및 바닥이 불연재료이고 관람석이 없는 운동시설은 제외한다)로서 다음의 어느 하나에 해당하는 경우에는 모든 층",
        subContent: [
          "가) 수용인원이 100명 이상인것",
          "나) 영화상영관의 용도로 쓰는 층의 바닥면적이 지하층 또는 무창층인 경우에는 500㎡ 이상, 그 밖의 층의 경우에는 1천㎡ 이상인 것",
          "다) 무대부가 지하층·무창층 또는 4층 이상의 층에 있는 경우에는 무대부의 면적이 300㎡ 이상인 것",
          "라) 무대부가 다) 외의 층에 있는 경우에는 무대부의 면적이 500㎡ 이상인 것",
        ],
      },
      {
        content:
          "판매시설, 운수시설 및 창고시설(물류터미널로 한정한다)로서 바닥면적의 합계가 5천㎡ 이상이거나 수용인원이 500명 이상인 경우에는 모든 층",
        subContent: null,
      },
      {
        content:
          "다음의 어느 하나에 해당하는 용도로 사용되는 시설은 바닥면적의 합계가 600 ㎡ 이상인 것은 모든 층",
        subContent: [
          "가) 근린생활시설 중 조산원 및 산후조리원",
          "나) 의료시설 중 정신의료기관",
          "다) 의료시설 중 종합병원, 병원, 치과병원, 한방병원 및 요양병원",
          "라) 노유자시설",
          "마) 숙박이 가능한 수련시설",
          "바) 숙박시설",
        ],
      },
      {
        content:
          "창고시설(물류터미널은 제외한다)로서 바닥면적 합계가 5천㎡ 이상인 경우에는 모든 층",
        subContent: null,
      },
      {
        content:
          "특정소방대상물의 지하층·무창층(축사는 제외한다) 또는 층수가 4층 이상인 층으로서 바닥면적이 1천㎡ 이상인 층이 있는 경우에는 해당 층",
        subContent: null,
      },
      {
        content:
          "랙크식 창고(rack warehouse) : 랙(물건을 수납할 수 있는 선반이나 이와 비슷한 것을 말한다. 이하 같다)을 갖춘 것으로서 천장 또는 반자(반자가 없는 경우에는 지붕의 옥내에 면하는 부분을 말한다)의 높이가 10m를 초과하고, 랙이 설치된 층의 바닥면적의 합계가 1천5백㎡ 이상인 경우에는 모든 층",
        subContent: null,
      },
      {
        content: "공장 또는 창고시설로서 다음의 어느 하나에 해당하는 시설",
        subContent: [
          "가) 「화재의 예방 및 안전관리에 관한 법률 시행령」 별표 2에서 정하는 수량의 1천 배 이상의 특수가연물을 저장·취급하는 시설",
          '나) 「원자력안전법 시행령」 제2조 제1호에 따른 중·저준위방사성폐기물(이하 "중·저준위방사성폐기물"이라 한다)의 저장시설 중 소화수를 수집·처리하는 설비가 있는 저장시설',
        ],
      },
      {
        content:
          "지붕 또는 외벽이 불연재료가 아니거나 내화구조가 아닌 공장 또는 창고시설로서 다음의 어느 하나에 해당하는 것",
        subContent: [
          "가) 창고시설(물류터미널로 한정한다) 중 4)에 해당하지 않는 것으로서 바닥면적의 합계가 2천5백㎡ 이상이거나 수용인원이 250명 이상인 경우에는 모든 층",
          "나) 창고시설(물류터미널은 제외한다) 중 6)에 해당하지 않는 것으로서 바닥면적의 합계가 2천5백㎡ 이상인 경우에는 모든 층",
          "다) 공장 또는 창고시설 중 7)에 해당하지 않는 것으로서 지하층·무창층 또는 층수가 4층 이상인 것 중 바닥면적이 500㎡ 이상인 경우에는 모든 층",
          "라) 랙식 창고 중 8)에 해당하지 않는 것으로서 바닥면적의 합계가 750㎡ 이상인 경우에는 모든 층",
          "마) 공장 또는 창고시설 중 9)가)에 해당하지 않는 것으로서 「화재의 예방 및 안전관리에 관한 법률 시행령」별표2에서 정하는 수량의 500배 이상의 특수가연물을 저장·취급하는 시설",
        ],
      },
      {
        content:
          "교정 및 군사시설 중 다음의 어느 하나에 해당하는 경우에는 해당 장소",
        subContent: [
          "가) 보호감호소, 교도소, 구치소 및 그 지소, 보호관찰소, 갱생보호시설, 치료감호시설, 소년원 및 소년분류심사원의 수용거실",
          "나) 「출입국관리법」 제52조 제2항에 따른 보호시설(외국인보호소의 경우에는 보호대상자의 생활공간으로 한정한다. 이하 같다)로 사용하는 부분. 다만, 보호시설이 임차건물에 있는 경우는 제외한다.",
          "다) 「경찰관 직무집행법」 제9조에 따른 유치장",
        ],
      },
      {
        content: "지하가(터널은 제외한다)로서 연면적 1천㎡ 이상인 것",
        subContent: null,
      },
      {
        content: "발전시설 중 전기저장시설",
        subContent: null,
      },
      {
        content:
          "1)부터 13)까지의 특정소방대상물에 부속된 보일러실 또는 연결통로 등",
        subContent: null,
      },
    ],
  },
  retardant: {
    image: "/Business_Info4.png",
    title: "방염",
    description:
      "방염 대상 소방대상물) 다음의 어느 하나에 해당하는 특정소방대상물은 방염조치를 의무적으로 해야 합니다",
    contents: [
      {
        content:
          "근린생활시설 중 의원, 조산원, 산후조리원, 체력단련장, 공연장 및 종교집회장",
        subContent: null,
      },
      {
        content:
          "건축물의 옥내에 있는 시설로서 문화 및 집회시설, 종교시설, 운동시설(수영장은 제외)",
        subContent: null,
      },
      {
        content: "의료시설",
        subContent: null,
      },
      {
        content: "교육연구시설 중 합숙소",
        subContent: null,
      },
      {
        content: "노유자 시설",
        subContent: null,
      },
      {
        content: "숙박이 가능한 수련시설",
        subContent: null,
      },
      {
        content: "숙박시설",
        subContent: null,
      },
      {
        content: "방송통신시설 중 방송국 및 촬영소",
        subContent: null,
      },
      {
        content: "다중이용업소",
        subContent: null,
      },
      {
        content:
          "위 1.부터 9.까지의 시설에 해당하지 않는 것으로서 층수가 11층 이상인 것(아파트등은 제외)",
        subContent: null,
      },
    ],
  },
  retardant2: {
    image: "",
    title: "방염대상물품의 종류",
    description: null,
    contents: [
      {
        content: "제조 또는 가공 공정에서 방염처리를 한 다음의 물품",
        subContent: [
          "가. 창문에 설치하는 커튼류(블라인드 포함)",
          "나. 카펫",
          "다. 벽지류(두께가 2밀리미터 미만인 종이벽지는 제외)",
          "라. 전시용 합판·목재 또는 섬유판, 무대용 합판·목재 또는 섬유판(합판·목재류의 경우 불가피하게 설치 현장에서 방염처리한 것을 포함)",
          "마. 암막·무대막(영화상영관에 설치하는 스크린과 가상체체험 체육시설업에 설치하는 스크린 포함)",
          "바. 섬유류 또는 합성수지류 등을 원료로 하여 제작된 소파·의자(단란주점영업, 유흥주점영업 및 노래연습장업의 영업장에 설치하는 것으로 한정)",
        ],
      },
      {
        content:
          "건축물 내부의 천장이나 벽에 부착하거나 설치하는 것으로서 다음의 것[다만, 가구류(옷장, 찬장, 식탁, 식탁용 의자, 사무용 책상, 사무용 의자, 계산대, 그 밖에 이와 비슷한 것을 말함)와 너비 10센티미터 이하인 반자돌림대 등과 내부 마감재료는 제외]",
        subContent: [
          "가. 종이류(두께 2밀리미터 이상인 것을 말함)·합성수지류 또는 섬유류를 주원료로 한 물품",
          "나. 합판이나 목재",
          "다. 공간을 구획하기 위하여 설치하는 간이 칸막이(접이식 등 이동 가능한 벽체나 천장 또는 반자가 실내에 접하는 부분까지 구획하지 않는 벽체를 말함)",
          "라. 흡음(吸音)을 위해 설치하는 흡음재(흡음용 커튼을 포함)",
          "마. 방음(防音)을 위해 설치하는 방음재(방음용 커튼을 포함)",
        ],
      },
      {
        content:
          "※ 소방본부장 또는 소방서장은 위 물품 외에 다음의 어느 하나에 해당하는 물품의 경우에는 방염 처리된 물품을 사용하도록 권장할 수 있습니다",
        subContent: [
          "1. 다중이용업소, 의료시설, 노유자시설, 숙박시설 또는 장례식장에서 사용하는 침구류·소파 및 의자",
          "2. 건축물 내부의 천장 또는 벽에 부착하거나 설치하는 가구류",
        ],
      },
    ],
  },
};
